export default "__VITE_ASSET__DMWMEoPP__"